import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./airdrops.css";

const AirdropsPage = () => {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="airdrops-page">
            <div className="airdrops-container">
                {/* --- Hero Section --- */}
                <div className="airdrops-hero">
                    <div className="airdrops-hero-content">
                        <div className="airdrop-badge">
                            <span className="airdrop-badge-icon">🎁</span> Airdrop Center
                        </div>
                        <h1 className="airdrops-hero-title">AGCX Airdrops</h1>
                        <p className="airdrops-hero-desc">
                            Complete tasks to receive token airdrops, claim early bird bonuses, and unlock exclusive benefits.
                        </p>
                        <div className="airdrops-tabs">
                            <button className="airdrop-tab active">Active</button>
                            <button className="airdrop-tab">Ended</button>
                            <button className="airdrop-tab">Upcoming</button>
                        </div>
                    </div>
                    <div className="airdrops-hero-image">
                        <img src="/images/airdrop-img/agce_airdrop_img.png" alt="AGCX Airdrops" />
                    </div>
                </div>

                {/* --- Active Airdrops Section --- */}
                <div className="airdrops-section-header">
                    <div className="airdrops-section-title-wrap">
                        <h2 className="airdrops-section-title">Active Airdrops</h2>
                        <span className="airdrops-count-badge">7</span>
                    </div>
                    <button className="airdrops-sort-btn">
                        Sort by <i className="ri-arrow-down-s-line"></i>
                    </button>
                </div>

                <div className="active-grid">
                    {/* Card 1 */}
                    <div className="airdrop-card">
                        <div>
                            <div className="airdrop-card-top">
                                <div className="airdrop-card-info">
                                    <div className="airdrop-card-avatar avatar-purple">P</div>
                                    <div className="airdrop-card-titles">
                                        <h3>Pharos Staking Airdrop</h3>
                                        <p>Staking</p>
                                    </div>
                                </div>
                                <span className="status-badge status-live">Live</span>
                            </div>

                            <div className="airdrop-tags">
                                <span className="airdrop-tag tag-sol">SOL</span>
                                <span className="airdrop-tag tag-eth">ETH</span>
                                <span className="airdrop-tag tag-defi">DeFi</span>
                                <span className="airdrop-tag tag-staking">Staking</span>
                            </div>

                            <div className="airdrop-metrics">
                                <div className="metric-group">
                                    <p>Reward</p>
                                    <h4>5,000 PHAROS</h4>
                                    <span>$1,200</span>
                                </div>
                                <div className="metric-group">
                                    <p style={{ textAlign: "right" }}>Participants</p>
                                    <div className="participants-count">
                                        <i className="ri-user-3-line"></i> 298
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button className="airdrop-join-btn" onClick={() => navigate('/airdrop-detail')}>
                            Join Now <i className="ri-external-link-line"></i>
                        </button>
                    </div>

                    {/* Card 2 */}
                    <div className="airdrop-card">
                        <div>
                            <div className="airdrop-card-top">
                                <div className="airdrop-card-info">
                                    <div className="airdrop-card-avatar avatar-gold">W</div>
                                    <div className="airdrop-card-titles">
                                        <h3>Web3 Polymarkets: Grand Final</h3>
                                        <p>Trading</p>
                                    </div>
                                </div>
                                <span className="status-badge status-live">Live</span>
                            </div>

                            <div className="airdrop-tags">
                                <span className="airdrop-tag tag-eth">ETH</span>
                                <span className="airdrop-tag tag-arb">ARB</span>
                                <span className="airdrop-tag tag-trading">Trading</span>
                                <span className="airdrop-tag tag-comp">Competition</span>
                            </div>

                            <div className="airdrop-metrics">
                                <div className="metric-group">
                                    <p>Reward</p>
                                    <h4>$1,000 USDT</h4>
                                    <span>$1,000</span>
                                </div>
                                <div className="metric-group">
                                    <p style={{ textAlign: "right" }}>Participants</p>
                                    <div className="participants-count">
                                        <i className="ri-user-3-line"></i> 482
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button className="airdrop-join-btn" onClick={() => navigate('/airdrop-detail')}>
                            Join Now <i className="ri-external-link-line"></i>
                        </button>
                    </div>

                    {/* Card 3 */}
                    <div className="airdrop-card">
                        <div>
                            <div className="airdrop-card-top">
                                <div className="airdrop-card-info">
                                    <div className="airdrop-card-avatar avatar-teal">R</div>
                                    <div className="airdrop-card-titles">
                                        <h3>Rhenium Airdrop</h3>
                                        <p>Airdrop</p>
                                    </div>
                                </div>
                                <span className="status-badge status-live">Live</span>
                            </div>

                            <div className="airdrop-tags">
                                <span className="airdrop-tag tag-eth">ETH</span>
                                <span className="airdrop-tag tag-token">Token</span>
                                <span className="airdrop-tag tag-free">Free</span>
                            </div>

                            <div className="airdrop-metrics">
                                <div className="metric-group">
                                    <p>Reward</p>
                                    <h4>4,000 RHENIUM</h4>
                                    <span>$800</span>
                                </div>
                                <div className="metric-group">
                                    <p style={{ textAlign: "right" }}>Participants</p>
                                    <div className="participants-count">
                                        <i className="ri-user-3-line"></i> 1,204
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button className="airdrop-join-btn" onClick={() => navigate('/airdrop-detail')}>
                            Join Now <i className="ri-external-link-line"></i>
                        </button>
                    </div>

                    {/* Card 4 */}
                    <div className="airdrop-card">
                        <div>
                            <div className="airdrop-card-top">
                                <div className="airdrop-card-info">
                                    <div className="airdrop-card-avatar avatar-red">R</div>
                                    <div className="airdrop-card-titles">
                                        <h3>Robinhood Clubs Trading Carnival</h3>
                                        <p>Competition</p>
                                    </div>
                                </div>
                                <span className="status-badge status-live">Live</span>
                            </div>

                            <div className="airdrop-tags">
                                <span className="airdrop-tag tag-sol">SOL</span>
                                <span className="airdrop-tag tag-bnb">BNB</span>
                                <span className="airdrop-tag tag-trading">Trading</span>
                                <span className="airdrop-tag tag-carnival">Carnival</span>
                            </div>

                            <div className="airdrop-metrics">
                                <div className="metric-group">
                                    <p>Reward</p>
                                    <h4>$2,000 USD</h4>
                                    <span>$2,000</span>
                                </div>
                                <div className="metric-group">
                                    <p style={{ textAlign: "right" }}>Participants</p>
                                    <div className="participants-count">
                                        <i className="ri-user-3-line"></i> 873
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button className="airdrop-join-btn" onClick={() => navigate('/airdrop-detail')}>
                            Join Now <i className="ri-external-link-line"></i>
                        </button>
                    </div>

                    {/* Card 5 */}
                    <div className="airdrop-card">
                        <div>
                            <div className="airdrop-card-top">
                                <div className="airdrop-card-info">
                                    <div className="airdrop-card-avatar avatar-purple">M</div>
                                    <div className="airdrop-card-titles">
                                        <h3>Mintfresh Airdrop</h3>
                                        <p>Airdrop</p>
                                    </div>
                                </div>
                                <span className="status-badge status-live">Live</span>
                            </div>

                            <div className="airdrop-tags">
                                <span className="airdrop-tag tag-stc">STC</span>
                                <span className="airdrop-tag tag-eth">ETH</span>
                                <span className="airdrop-tag tag-nft">NFT</span>
                                <span className="airdrop-tag tag-mint">Mint</span>
                            </div>

                            <div className="airdrop-metrics">
                                <div className="metric-group">
                                    <p>Reward</p>
                                    <h4>10,000 MINTFRESH</h4>
                                    <span>$500</span>
                                </div>
                                <div className="metric-group">
                                    <p style={{ textAlign: "right" }}>Participants</p>
                                    <div className="participants-count">
                                        <i className="ri-user-3-line"></i> 3,120
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button className="airdrop-join-btn" onClick={() => navigate('/airdrop-detail')}>
                            Join Now <i className="ri-external-link-line"></i>
                        </button>
                    </div>

                    {/* Card 6 */}
                    <div className="airdrop-card">
                        <div>
                            <div className="airdrop-card-top">
                                <div className="airdrop-card-info">
                                    <div className="airdrop-card-avatar avatar-cyan">Z</div>
                                    <div className="airdrop-card-titles">

                                        <h3>ZetaChain Airdrop</h3>
                                        <p>Airdrop</p>
                                    </div>
                                </div>
                                <span className="status-badge status-live">Live</span>
                            </div>

                            <div className="airdrop-tags">
                                <span className="airdrop-tag tag-zeta">ZETA</span>
                                <span className="airdrop-tag tag-layer1">Layer1</span>
                                <span className="airdrop-tag tag-free">Cross-chain</span>
                            </div>

                            <div className="airdrop-metrics">
                                <div className="metric-group">
                                    <p>Reward</p>
                                    <h4>250,000 ZEX</h4>
                                    <span>$500</span>
                                </div>
                                <div className="metric-group">
                                    <p style={{ textAlign: "right" }}>Participants</p>
                                    <div className="participants-count">
                                        <i className="ri-user-3-line"></i> 7,440
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button className="airdrop-join-btn" onClick={() => navigate('/airdrop-detail')}>
                            Join Now <i className="ri-external-link-line"></i>
                        </button>
                    </div>

                    {/* Card 7 */}
                    <div className="airdrop-card">
                        <div>
                            <div className="airdrop-card-top">
                                <div className="airdrop-card-info">
                                    <div className="airdrop-card-avatar avatar-gold">W</div>
                                    <div className="airdrop-card-titles">
                                        <h3>Web3 Cup: Polymarkets Trading Competition</h3>
                                        <p>Competition</p>
                                    </div>
                                </div>
                                <span className="status-badge status-live">Live</span>
                            </div>

                            <div className="airdrop-tags">
                                <span className="airdrop-tag tag-eth">ETH</span>
                                <span className="airdrop-tag tag-sol">SOL</span>
                                <span className="airdrop-tag tag-comp">Competition</span>
                                <span className="airdrop-tag tag-trading">Trading</span>
                            </div>

                            <div className="airdrop-metrics">
                                <div className="metric-group">
                                    <p>Reward</p>
                                    <h4>150,000 Tokens</h4>
                                    <span>$3,000</span>
                                </div>
                                <div className="metric-group">
                                    <p style={{ textAlign: "right" }}>Participants</p>
                                    <div className="participants-count">
                                        <i className="ri-user-3-line"></i> 2,051
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button className="airdrop-join-btn" onClick={() => navigate('/airdrop-detail')}>
                            Join Now <i className="ri-external-link-line"></i>
                        </button>
                    </div>
                </div>

                {/* --- Ended Airdrops Section --- */}
                <div className="airdrops-section-header">
                    <h2 className="airdrops-section-title">Ended Airdrops</h2>
                    <a href="#view-more" className="airdrops-view-more">View More</a>
                </div>

                <div className="ended-grid">
                    {/* Ended Card 1 */}
                    <div className="ended-card">
                        <div className="ended-card-left">
                            <div className="ended-avatar avatar-grey">A</div>
                            <div className="ended-info">
                                <h4>AI Trading Competition S</h4>
                                <p>1,000 USDT</p>
                                <p><i className="ri-group-line"></i> 4,200</p>
                            </div>
                        </div>
                        <span className="status-badge status-ended">Ended</span>
                    </div>

                    {/* Ended Card 2 */}
                    <div className="ended-card">
                        <div className="ended-card-left">
                            <div className="ended-avatar avatar-purple">Z</div>
                            <div className="ended-info">
                                <h4>ZEX Trading Competition</h4>
                                <p>2,400</p>
                                <p><i className="ri-group-line"></i> 8,820</p>
                            </div>
                        </div>
                        <span className="status-badge status-ended">Ended</span>
                    </div>

                    {/* Ended Card 3 */}
                    <div className="ended-card">
                        <div className="ended-card-left">
                            <div className="ended-avatar avatar-gold">B</div>
                            <div className="ended-info">
                                <h4>Bybit Airdrop</h4>
                                <p>Participate</p>
                                <p><i className="ri-group-line"></i> 12,400</p>
                            </div>
                        </div>
                        <span className="status-badge status-ended">Ended</span>
                    </div>

                    {/* Ended Card 4 */}
                    <div className="ended-card">
                        <div className="ended-card-left">
                            <div className="ended-avatar avatar-pink">J</div>
                            <div className="ended-info">
                                <h4>Jupiter Airdrop Venture</h4>
                                <p>JUP Tokens</p>
                                <p><i className="ri-group-line"></i> 31,200</p>
                            </div>
                        </div>
                        <span className="status-badge status-ended">Ended</span>
                    </div>
                </div>

                {/* --- Partner Banner Section --- */}
                <div className="airdrop-partner-banner">
                    <div className="partner-banner-content">
                        <div className="partner-banner-subtitle">Partner With AGCX Web3</div>
                        <h2 className="partner-banner-title">Apply to list your project in the Airdrop Center</h2>
                        <p className="partner-banner-desc">Reach thousands of active crypto participants worldwide.</p>
                    </div>
                    <div className="partner-banner-image">
                        <img src="/images/airdrop-img/airdrop_project_img.png" alt="List your project" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AirdropsPage;
